import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const CustomerReferral = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const referralCode = queryParams.get('referralCode');

    useEffect(() => {


        const deepLink = `myapp://com.deliva.customer?referralCode=${referralCode}`;
        const androidStoreUrl = `https://play.google.com/store/apps/details?id=com.deliva.customer`;
        const iosStoreUrl = `https://apps.apple.com/in/app/delivahere/id6499013194`;

        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        setTimeout(() => {
            window.location.href = isIOS ? iosStoreUrl : androidStoreUrl;
        }, 5000);

        window.location.href = deepLink;
    }, [])
    return (
        <div class="d-flex justify-content-center align-items-center vh-100">
            <h1 class="text-center">Please wait...</h1>
        </div>
    );
}

export default CustomerReferral